import { ButtonHTMLAttributes, FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from 'src/lib/utils';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  to?: string;
}

export const Button: FC<ButtonProps> = ({
  children,
  className = '',
  text,
  to,
  onClick,
  ...props
}) => {
  const navigate = useNavigate();

  return (
    <button
      className={cn('button h-14 px-8 text-15 font-semibold', className)}
      onClick={to ? () => navigate(to) : onClick}
      {...props}
    >
      {text ?? children}
    </button>
  );
};
